/**
 * Static registry of MUI icons used by dynamic-icon components (NavigationTile, Tab).
 *
 * These components receive an icon *name* as a string (e.g. "People") and need
 * to resolve it to a React component at runtime.  Previously they did
 * `import * as Icons from '@mui/icons-material'` which pulled the entire
 * 3.6 MB icon library into a single chunk — downloaded on every page load.
 *
 * This registry imports only the ~35 icons actually referenced in tile/tab
 * configs, reducing the bundle by ~3.5 MB.
 *
 * To add a new icon: import it below and add it to the ICON_REGISTRY map.
 */
import type { SvgIconComponent } from '@mui/icons-material';

import AccountBalance from '@mui/icons-material/AccountBalance';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings';
import Apps from '@mui/icons-material/Apps';
import Assessment from '@mui/icons-material/Assessment';
import Assignment from '@mui/icons-material/Assignment';
import AttachMoney from '@mui/icons-material/AttachMoney';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Autorenew from '@mui/icons-material/Autorenew';
import Build from '@mui/icons-material/Build';
import Business from '@mui/icons-material/Business';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CalendarToday from '@mui/icons-material/CalendarToday';
import Chat from '@mui/icons-material/Chat';
import CheckBox from '@mui/icons-material/CheckBox';
import ChecklistRtl from '@mui/icons-material/ChecklistRtl';
import CloudUpload from '@mui/icons-material/CloudUpload';
import Description from '@mui/icons-material/Description';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Folder from '@mui/icons-material/Folder';
import History from '@mui/icons-material/History';
import MailOutline from '@mui/icons-material/MailOutline';
import MedicalServices from '@mui/icons-material/MedicalServices';
import MenuBook from '@mui/icons-material/MenuBook';
import NoteAdd from '@mui/icons-material/NoteAdd';
import Payment from '@mui/icons-material/Payment';
import People from '@mui/icons-material/People';
import PersonAdd from '@mui/icons-material/PersonAdd';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import RocketLaunch from '@mui/icons-material/RocketLaunch';
import Security from '@mui/icons-material/Security';
import Settings from '@mui/icons-material/Settings';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Warning from '@mui/icons-material/Warning';

const ICON_REGISTRY: Record<string, SvgIconComponent> = {
  AccountBalance,
  AccountCircle,
  AdminPanelSettings,
  Apps,
  Assessment,
  Assignment,
  AttachMoney,
  AutoAwesome,
  Autorenew,
  Build,
  Business,
  CalendarMonth,
  CalendarToday,
  Chat,
  CheckBox,
  ChecklistRtl,
  CloudUpload,
  Description,
  DirectionsCar,
  FavoriteBorder,
  Folder,
  History,
  MailOutline,
  MedicalServices,
  MenuBook,
  NoteAdd,
  Payment,
  People,
  PersonAdd,
  ReceiptLong,
  RocketLaunch,
  Security,
  Settings,
  TrendingUp,
  Warning,
};

export default ICON_REGISTRY;

/** Default icon when the requested name isn't in the registry. */
export const DEFAULT_ICON = Apps;
